export default {
  title: 'Vaše SVJ je připravené',

  Modal: {
    badge: 'Benefit od partnera {{partner}}',
    title: '{{building}} je připravené',
    subtitle:
      'Dům je načtený z katastru a plná licence je aktivní{{licenseUntil}} – hrazená partnerem {{partner}}. Zbývá si zvolit heslo a potvrdit podmínky, pak jste rovnou v aplikaci.',
    licenseUntil: ' do {{date}}',
    fieldsTitle: 'Přihlašovací údaje',
    agreementsTitle: 'Souhlasy',
    error: 'Dokončení přístupu se nepodařilo, zkuste to prosím znovu.',
    footer: 'Dotazy? Odpovězte na e-mail, kterým jste odkaz dostali, nebo napište na pomoc@evlastnici.cz.',

    Fields: {
      Email: {
        label: 'Přihlašovací e-mail',
        placeholder: 'E-mail, kterým se budete přihlašovat',
      },
      Password: {
        label: 'Nové heslo',
        placeholder: 'Zvolte si heslo do aplikace',
      },
      PasswordCheck: {
        label: 'Nové heslo znovu',
        placeholder: 'Zadejte heslo znovu',
        matches: 'Hesla se musí shodovat',
      },
      TermsAndConditions: {
        label: 'Souhlasím s',
        label_2: 'všeobecnými obchodními podmínkami',
        required: 'K dokončení potřebujeme souhlas s všeobecnými obchodními podmínkami.',
      },
      License: {
        label: 'Souhlasím s',
        label_2: 'licenční smlouvou',
        required: 'K dokončení potřebujeme souhlas s licenční smlouvou.',
      },
      Gdpr: {
        label: 'Beru na vědomí',
        label_2: 'prohlášení o ochraně osobních údajů',
        required: 'K dokončení potřebujeme potvrzení, že jste se seznámil(a) s ochranou osobních údajů.',
      },
      Admin: {
        label: 'Potvrzuji, že jsem oprávněn(a) jednat za toto společenství vlastníků (předseda, člen výboru, správce).',
        required: 'Aplikaci za SVJ může spravovat jen oprávněná osoba.',
      },
      Marketing: {
        label: 'Souhlasím se',
        label_2: 'zasíláním novinek a tipů pro správu domu',
      },
      Submit: {
        title: 'Vstoupit do aplikace',
      },
    },
  },

  Expired: {
    title: 'Tento odkaz už neplatí',
    text: 'Odkaz z e-mailu má omezenou platnost, nebo už byl použit. Pokud máte heslo, přihlaste se. Jinak nám napište na pomoc@evlastnici.cz a pošleme vám nový.',
    button: 'Přejít na přihlášení',
  },
};
